"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemColors = void 0;
exports.SystemColors = {
    // Black and White
    black: "#000000",
    white: "#FFFFFF",
    // Grays
    "color-system-gray-50": "#F5F5F6",
    "color-system-gray-100": "#E9E9E9",
    "color-system-gray-200": "#E0E0E0",
    "color-system-gray-300": "#AEB0B3",
    "color-system-gray-400": "#86888E",
    "color-system-gray-500": "#696B72",
    "color-system-gray-600": "#58595B",
    "color-system-gray-700": "#4C4E52",
    "color-system-gray-800": "#434447",
    "color-system-gray-900": "#3B3B3E",
    "color-system-gray-950": "#252627",
    // Reds
    "color-system-red-50": "#FEF2F2",
    "color-system-red-100": "#FDE3E2",
    "color-system-red-200": "#FCCCCC",
    "color-system-red-300": "#F9A9A8",
    "color-system-red-400": "#F58A8A",
    "color-system-red-500": "#E94A49",
    "color-system-red-600": "#D62C2B",
    "color-system-red-700": "#B22222",
    "color-system-red-800": "#951F1F",
    "color-system-red-900": "#7C1F20",
    "color-system-red-950": "#430D0B",
    // Yellows
    "color-system-yellow-50": "#FDFBEC",
    "color-system-yellow-100": "#FCF3C9",
    "color-system-yellow-200": "#F9E58D",
    "color-system-yellow-300": "#F7D252",
    "color-system-yellow-400": "#F5C131",
    "color-system-yellow-500": "#EF9E12",
    "color-system-yellow-600": "#D4780B",
    "color-system-yellow-700": "#AF560D",
    "color-system-yellow-800": "#8E4312",
    "color-system-yellow-900": "#753713",
    "color-system-yellow-950": "#431C05",
    // Greens
    "color-system-green-50": "#EDFBF2",
    "color-system-green-100": "#D5F6DF",
    "color-system-green-200": "#B0EBC6",
    "color-system-green-300": "#7BDAA6",
    "color-system-green-400": "#45C282",
    "color-system-green-500": "#22A767",
    "color-system-green-600": "#158A55",
    "color-system-green-700": "#106C45",
    "color-system-green-800": "#0E5638",
    "color-system-green-900": "#0E462F",
    "color-system-green-950": "#06281B",
    // Blues
    "color-system-blue-50": "#EFF7FF",
    "color-system-blue-100": "#DAEDFF",
    "color-system-blue-200": "#BEE1FF",
    "color-system-blue-300": "#91CFFF",
    "color-system-blue-400": "#5DB4FD",
    "color-system-blue-500": "#3893F9",
    "color-system-blue-600": "#2175EF",
    "color-system-blue-700": "#1858CD",
    "color-system-blue-800": "#184DB2",
    "color-system-blue-900": "#1C438C",
    "color-system-blue-950": "#162A55"
};
//# sourceMappingURL=SystemColors.js.map